import { Node, ReactNodeViewRenderer } from "@tiptap/react";
import { ImageUpload as ImageUploadComponent } from "./view/image-upload.tsx";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    imageUpload: {
      setImageUpload: () => ReturnType;
      removeImageUploads: () => ReturnType;
    };
  }
}

export const ImageUpload = Node.create({
  name: "imageUpload",

  isolating: true,

  defining: true,

  group: "block",

  draggable: true,

  selectable: true,

  inline: false,

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML() {
    return ["div", { "data-type": this.name }];
  },

  addCommands() {
    return {
      setImageUpload:
        () =>
        ({ commands }) =>
          commands.insertContent(`<div data-type="${this.name}"></div>`),
      // Remove all image uploads from the editor
      removeImageUploads:
        () =>
        ({ state, dispatch }) => {
          const { tr } = state;
          let modified = false;

          state.doc.descendants((node, pos) => {
            const isUnusedImageUpload = node.type.name === "imageUpload";

            if (isUnusedImageUpload) {
              tr.delete(pos, pos + node.nodeSize);
              modified = true;
            }
          });

          if (modified && dispatch) {
            dispatch(tr);
          }

          return modified;
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageUploadComponent);
  },
});

export default ImageUpload;
